import { useTranslation } from 'react-i18next';
import SharedNavbar from '@/components/feature/SharedNavbar';
import SharedFooter from '@/components/feature/SharedFooter';
import { Seo } from '@/components/Seo';
import { useSiteDesign } from '@/hooks/useSiteDesign';
import LegalV2 from '@/pages/info/v2/LegalV2';

export default function TermsOfServicePage() {
  const { isNew } = useSiteDesign();
  return isNew ? <LegalV2 prefix="terms" count={10} pageKey="terms" /> : <ClassicTermsOfServicePage />;
}

function ClassicTermsOfServicePage() {
  const { t } = useTranslation();

  const sections = [
    { title: t('terms.section1.title'), body: t('terms.section1.body') },
    { title: t('terms.section2.title'), body: t('terms.section2.body') },
    { title: t('terms.section3.title'), body: t('terms.section3.body') },
    { title: t('terms.section4.title'), body: t('terms.section4.body') },
    { title: t('terms.section5.title'), body: t('terms.section5.body') },
    { title: t('terms.section6.title'), body: t('terms.section6.body') },
    { title: t('terms.section7.title'), body: t('terms.section7.body') },
    { title: t('terms.section8.title'), body: t('terms.section8.body') },
    { title: t('terms.section9.title'), body: t('terms.section9.body') },
    { title: t('terms.section10.title'), body: t('terms.section10.body') },
  ];

  return (
    <main className="w-full min-h-screen bg-white font-sans">
      <Seo pageKey="terms" />
      <SharedNavbar />

      {/* ===== HERO ===== */}
      <section className="w-full bg-[#1A1A1A] pt-28 pb-16 md:pt-32 md:pb-20 px-6 md:px-12 lg:px-20">
        <div className="max-w-7xl mx-auto text-center">
          <div className="flex items-center justify-center gap-3 mb-5">
            <div className="w-6 h-px bg-[#7B1113]" />
            <span className="text-[11px] tracking-[0.2em] uppercase text-[#7B1113] font-medium">
              {t('terms.hero.label')}
            </span>
            <div className="w-6 h-px bg-[#7B1113]" />
          </div>
          <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-[1.15] mb-4">
            {t('terms.hero.heading')}
          </h1>
          <p className="text-sm text-white/40 font-light max-w-lg mx-auto">
            {t('terms.lastUpdated')}
          </p>
        </div>
      </section>

      {/* ===== CONTENT ===== */}
      <section className="w-full bg-white py-16 md:py-24 px-6 md:px-12 lg:px-20">
        <div className="max-w-3xl mx-auto flex flex-col gap-10">
          {sections.map((sec) => (
            <div key={sec.title}>
              <h2 className="font-serif text-xl font-bold text-[#2A2A2A] mb-3">
                {sec.title}
              </h2>
              <p className="text-sm text-[#5A5A5A] font-light leading-[1.9] whitespace-pre-line">
                {sec.body}
              </p>
            </div>
          ))}
        </div>
      </section>

      <SharedFooter />
    </main>
  );
}